import { action } from 'typesafe-actions';
// eslint-disable-next-line no-unused-vars
import {
  SegmentationInterface,
  SegmentationValuesInterface,
  SegmentationsTypes,
} from './types';

// List Segmentations
export const listSegmentationsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(SegmentationsTypes.LIST_SEGMENTATIONS_REQUEST, payload);
export const listSegmentationsSuccess = (payload: {
  segmentations: SegmentationInterface[];
  totalCount: number;
}) => action(SegmentationsTypes.LIST_SEGMENTATIONS_SUCCESS, payload);
export const listSegmentationsFailure = () =>
  action(SegmentationsTypes.LIST_SEGMENTATIONS_FAILURE);

// List Segmentations Values
export const listSegmentationValuesRequest = (payload: object) =>
  action(SegmentationsTypes.LIST_SEGMENTATION_VALUES_REQUEST, payload);
export const listSegmentationValuesSuccess = (payload: {
  segmentationValues: SegmentationValuesInterface[];
}) => action(SegmentationsTypes.LIST_SEGMENTATION_VALUES_SUCCESS, payload);
export const listSegmentationValuesFailure = () =>
  action(SegmentationsTypes.LIST_SEGMENTATION_VALUES_FAILURE);

// Get Segmentation
export const getSegmentationRequest = (payload: object) =>
  action(SegmentationsTypes.GET_SEGMENTATION_REQUEST, payload);
export const getSegmentationSuccess = (payload: {
  segmentationData: SegmentationInterface;
}) => action(SegmentationsTypes.GET_SEGMENTATION_SUCCESS, payload);
export const getSegmentationFailure = () =>
  action(SegmentationsTypes.GET_SEGMENTATION_FAILURE);

// Create Segmentation
export const createSegmentationRequest = (payload: object) =>
  action(SegmentationsTypes.CREATE_SEGMENTATION_REQUEST, payload);
export const createSegmentationSuccess = () =>
  action(SegmentationsTypes.CREATE_SEGMENTATION_SUCCESS);
export const createSegmentationFailure = () =>
  action(SegmentationsTypes.CREATE_SEGMENTATION_FAILURE);

// Update Segmentation
export const updateSegmentationRequest = (payload: object) =>
  action(SegmentationsTypes.UPDATE_SEGMENTATION_REQUEST, payload);
export const updateSegmentationSuccess = () =>
  action(SegmentationsTypes.UPDATE_SEGMENTATION_SUCCESS);
export const updateSegmentationFailure = () =>
  action(SegmentationsTypes.UPDATE_SEGMENTATION_FAILURE);

// Delete Segmentation
export const deleteSegmentationRequest = (payload: object) =>
  action(SegmentationsTypes.DELETE_SEGMENTATION_REQUEST, payload);
export const deleteSegmentationSuccess = () =>
  action(SegmentationsTypes.DELETE_SEGMENTATION_SUCCESS);
export const deleteSegmentationFailure = () =>
  action(SegmentationsTypes.DELETE_SEGMENTATION_FAILURE);

// Create Segmentations
export const createSegmentationsRequest = (payload: Array<object>) =>
  action(SegmentationsTypes.CREATE_SEGMENTATIONS_REQUEST, payload);
export const createSegmentationsSuccess = () =>
  action(SegmentationsTypes.CREATE_SEGMENTATIONS_SUCCESS);
export const createSegmentationsFailure = () =>
  action(SegmentationsTypes.CREATE_SEGMENTATIONS_FAILURE);

// Update Segmentations
export const updateSegmentationsRequest = (payload: object) =>
  action(SegmentationsTypes.UPDATE_SEGMENTATIONS_REQUEST, payload);
export const updateSegmentationsSuccess = () =>
  action(SegmentationsTypes.UPDATE_SEGMENTATIONS_SUCCESS);
export const updateSegmentationsFailure = () =>
  action(SegmentationsTypes.UPDATE_SEGMENTATIONS_FAILURE);

// Delete Segmentations
export const deleteSegmentationsRequest = (payload: object) =>
  action(SegmentationsTypes.DELETE_SEGMENTATIONS_REQUEST, payload);
export const deleteSegmentationsSuccess = () =>
  action(SegmentationsTypes.DELETE_SEGMENTATIONS_SUCCESS);
export const deleteSegmentationsFailure = () =>
  action(SegmentationsTypes.DELETE_SEGMENTATIONS_FAILURE);
